/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ErroreClientOccorrenzaDTO { 
    id?: string;
    soggetto_tipo?: string;
    actor_user_id?: string;
    actor_snapshot?: string;
    actor_type?: string;
    giorno?: string;
    contatore?: number;
    prima_volta?: string;
    ultima_volta?: string;
    app?: string;
    versione_app?: string;
    piattaforma?: string;
    user_agent?: string;
    comune_slug?: string;
    pagina?: string;
    messaggio?: string;
    stack?: string;
}

